import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxLoadingModule } from 'ngx-loading';
import { NavbarComponent } from '../navbar/navbar.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';

@NgModule({
  declarations: [
    NavbarComponent,
    MainLayoutComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgxLoadingModule.forRoot({}),
  ]
})
export class LayoutModule { }
